import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from 'redux/store';

import { BANNER_MEASURE_LINK_NAME } from '../../constants';

/**
 * 類似キーワードがある際の求人の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ求人閲覧AA計測
 */
export const measureSimilarKeywordJob =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_etsuran', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_etsuran', {});
    }
  };

/**
 * 類似キーワードがある際の気になる押下時の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ気になるクリックAA計測
 */
export const measureSimilarKeywordFavorite =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_favorite', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_fovorite', {});
    }
  };

/**
 * 類似キーワードがある際の応募押下時の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ応募クリックAA計測
 */
export const measureSimilarKeywordApplyJob =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_oubo', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_oubo', {});
    }
  };

/**
 * Event Type Actions
 * Mapping of event types to their measurement link names.
 */
const EVENT_TYPE_ACTIONS = {
  bannerDisplayed: BANNER_MEASURE_LINK_NAME.BANNER_DISPLAYED,
  registerClicked: BANNER_MEASURE_LINK_NAME.REGISTER_CLICKED,
} as const;

/**
 * Measure registration suggestion banner
 * @param {string} eventType - EventType ('bannerDisplayed', 'registerClicked')
 * @returns
 */
export const measureRegistSuggestionBanner =
  (eventType: keyof typeof EVENT_TYPE_ACTIONS): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const prop23 = 'PC_listcv';
    const pageName = 'PC_フォーム流入_一覧_フォーム流入';
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    const customLink = EVENT_TYPE_ACTIONS[eventType];
    const option =
      customLink === BANNER_MEASURE_LINK_NAME.REGISTER_CLICKED
        ? {
            pageName,
            linkTrackVars: 'prop23,eVar23',
            prop23,
            eVar23: 'D=c23',
          }
        : {};

    if (customLink) {
      tlReadyExecute(isAdobeScript, dispatch, customLink, option);
    }
  };
